export const formatUserQRDate = (value: unknown) => {
  if (!value) return "--"
  const valueWithToDate = value as { toDate?: () => Date }
  const date = valueWithToDate?.toDate ? valueWithToDate.toDate() : new Date(value as string | number | Date)
  return Number.isNaN(date.getTime()) ? "--" : date.toLocaleString()
}

export const buildUserQRPublicUrl = (id: string) => `https://winfacil.com/uqr?i=${encodeURIComponent(id)}`
